export default class BlockGallery {
    constructor(container, options) {
        const defaultOptions = {
            splide: '.splide',
            desktopSlider: true,
            mobileSlider: false
        };
        this.options = Object.assign({}, defaultOptions, options);

        this.container = document.querySelector(container);
        this.splide = this.container.querySelector(this.options.splide);

        this.initSplider();
    }
    
    initSplider() {
        
        new Splide(this.splide,{
            type   : 'loop',
            drag   : 'free',
            focus  : 'center',
            perPage: 3,
            destroy: !this.options.desktopSlider,
            breakpoints: {
                768: {
                    perPage: 1,
                    destroy: !this.options.mobileSlider
                }
            },
            gap: '30px',
            pagination: false,
            autoScroll: {
              speed: 1,
            }
        
          }).mount(window.splide.Extensions);
    }
}